export const config = {apiUrl: '/'};